import { FC } from "react";
import OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent from "./step-summary/order-optimizer-cargo-details-hidden-details-center-tables-orders-step-summary.component";
import OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderSummaryComponent from "./order-summary/order-optimizer-cargo-details-hidden-details-center-tables-orders-order-summary.component";
import OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent from "./order/order-optimizer-cargo-details-hidden-details-center-tables-orders-order-table.component";
import {
  OrderOptimizerCargoDetailsItemStepsOrdersPoints,
  OrderOptimizerCargoDetailsItemOrders,
  OrderOptimizerCargoDetailsItemStepsOrders,
  OrderOptimizerCargoDetailsItemStepsLastPoint,
} from "../../../common/types/order-optimizer-cargo-details-item";

type OrderOptimizerCargoDetailsHiddenDetailsTablesOrdersProps = {
  allStepPoints: OrderOptimizerCargoDetailsItemStepsOrdersPoints[];
  order: OrderOptimizerCargoDetailsItemOrders;
  step: OrderOptimizerCargoDetailsItemStepsOrders;
  stepOffset: number;
  orderIndex: number;
  lastPoint: OrderOptimizerCargoDetailsItemStepsLastPoint | null;
};

const OrderOptimizerCargoDetailsHiddenDetailsTablesOrdersComponent: FC<
  OrderOptimizerCargoDetailsHiddenDetailsTablesOrdersProps
> = (props) => {
  return (
    <>
      <div className="order_optimizer_cargo_details_hidden_details_center_tables_orders">
        <div className="order_optimizer_cargo_details_hidden_details_center_tables_orders__left">
          <OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderSummaryComponent
            order={props.order}
            orderIndex={props.orderIndex}
          />
        </div>
        <div className="order_optimizer_cargo_details_hidden_details_center_tables_orders__right">
          <div className="order_optimizer_cargo_details_hidden_details_center_tables_orders__right__order">
            <OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent
              allStepPoints={props.allStepPoints}
              stepPoints={props.step.points}
              stepOffset={props.stepOffset}
              lastPoint={props.lastPoint}
            />
          </div>
          <div className="order_optimizer_cargo_details_hidden_details_center_tables_orders__right__summary">
            <OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent
              step={props.step}
              lastPoint={props.lastPoint}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderOptimizerCargoDetailsHiddenDetailsTablesOrdersComponent;
